import React from 'react';
import { observer } from 'mobx-react-lite';
import ComparableExpensesUnitsModal from './ComparableExpensesUnitsModal';
import { Filter, PropertySummary, SubjectExpenses, TotalOperatingExpenses, FetchExpenseCompsParams } from './types';
import { useRootStore } from 'stores/RootStore';
import { ExpenseComp } from 'types/underwriting/income-approach/expenses';

interface ContainerProps {
  onAddExpenseComps: (comps: ExpenseComp[]) => void;
  handleClose: () => void;
  filters?: Filter[];
  propertySummary: PropertySummary;
  totalOperatingExpenses: TotalOperatingExpenses;
  subjectExpenses: SubjectExpenses;
  totalSubjectOperatingExpenses?: TotalOperatingExpenses;
  totalSubjectOperatingExpensesNetTaxes?: TotalOperatingExpenses;
  addedExpenseComps?: ExpenseComp[];
  isExpenseCompsDisabled?: boolean;
  reportId?: string;
}

const ComparableExpensesUnitsModalContainer: React.FC<ContainerProps> = observer((props) => {
  const { expenseCompsStore } = useRootStore();

  const handleFetchExpenseComps = async (params: FetchExpenseCompsParams) => {
    return await expenseCompsStore.fetchExpenseComps(params);
  };

  return (
    <ComparableExpensesUnitsModal
      {...props}
      onFetchExpenseComps={handleFetchExpenseComps}
      selectedExpenseComps={expenseCompsStore.selectedExpenseComps}
    />
  );
});

export default ComparableExpensesUnitsModalContainer;
